import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import SchoolIcon from "@mui/icons-material/School";
import { Menu } from "@mui/material";
import React from "react";

import { SidebarMessages } from "@/messages/layout/sidebar";
import NotificationItem from "@/mui/Items/NotificationItem";

interface HelpPopoverProps {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: SidebarMessages;
}

export function HelpPopover({ isOpen, anchorEl, onClose, messages }: HelpPopoverProps) {
  const openInNewTab = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const { talkToSupport, knowledgeBase } = messages;

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      sx={{ mt: 2 }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <NotificationItem
        onClick={() => openInNewTab("https://talk2buy.tomticket.com")}
        icon={<ContactSupportIcon />}
        title={talkToSupport}
      />

      <NotificationItem
        onClick={() => openInNewTab("https://talk2buy.tomticket.com/kb")}
        icon={<SchoolIcon />}
        title={knowledgeBase}
      />
    </Menu>
  );
}
